import { render, staticRenderFns } from "./farm.vue?vue&type=template&id=8999da40&scoped=true&"
import script from "./farm.vue?vue&type=script&lang=js&"
export * from "./farm.vue?vue&type=script&lang=js&"
import style0 from "./farm.vue?vue&type=style&index=0&id=8999da40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8999da40",
  null
  
)

export default component.exports